import React, { Component } from 'react'
import clsx from 'clsx'
import { withStyles } from '@material-ui/core/styles'
import {
  Typography,
  ExpansionPanel,
  ExpansionPanelDetails,
  ExpansionPanelSummary,
  Paper,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TablePagination,
} from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import {ImSortAlphaAsc, ImSortAlphaDesc, ImSortNumericAsc, ImSortNumbericDesc} from 'react-icons/im'

const styles = theme => ({
  paper: {
    width: '100%',
    border: '1px solid #283891'
  },
  table: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  title: {
    fontSize: '14px',
    fontWeight: 'bold',
  },
  header: {
    color: 'rgba(255, 255, 255, 1.0)',
    fontWeight: 700,
    '&:hover': {
      cursor: 'pointer',
      color: '#25aae1'
    }
  },
  details: {
    alignItems: 'right'
  },
  column: {
    flexBasis: '50%'
  },
  total: {
    fontWeight: 700,
    color: 'rgba(92, 92, 92)',
    flexBasis: '50%'
  },
  totalDark: {
    fontWeight: 700,
    color: 'rgba(255, 255, 255)',
    flexBasis: '50%'
  }
})

class Locations extends Component {
  constructor(props) {
    super(props)
    this.state = {
      rowsPerPage: props.data.length > 20 ? Math.round((props.data.length / 4) / 10) * 10 : Math.round((props.data.length / 4) / 5) * 5,
      page: 0,
      dataOrdered: props.data,
      orderedBy: 'Label',
      order: 'DSC',
    }
  }

  componentDidMount = () => {
    this.state.dataOrdered.forEach(item => {
      item.total['Res_Rate'] = item.total.Mailed > 0 ? item.total.Responses / item.total.Mailed : 0
      item.total['HO_Res_Rate'] = item.total.HO_Count > 0 ? item.total.HO_Resp / item.total.HO_Count : 0
      item.total['ADJ_Res_Rate'] = item.total['Res_Rate'] * 100 > 0 && item.total['HO_Res_Rate'] * 100 > 0 ? (item.total.Res_Rate - item.total.HO_Res_Rate) : 0
      item.total['Avg_Ticket'] = item.total.Responses > 0 ? item.total.Sales / item.total.Responses : 0
    })
  }

  handleChangePage = (e, newPage) => {
    this.setState({
      page: newPage
    })
  }

  handleChangeRowsPerPage = e => {
    this.setState({
      rowsPerPage: parseInt(e.target.value),
      page: 0
    })
  }

  handleSortColumn = (description) => {
    if(typeof this.props.data[0].total[description] === 'string') {
      if(this.state.orderedBy === description) {
        if(this.state.order === 'DSC') {
          this.setState({
            dataOrdered: this.props.data.sort((a,b) => b.total[description].localeCompare(a.total[description])),
            order: 'ASC',
          })
        } else {
          this.setState({
            dataOrdered: this.props.data.sort((a,b) => a.total[description].localeCompare(b.total[description])),
            order: 'DSC',
          })
        }
      } else {
        this.setState({
          dataOrdered: this.props.data.sort((a,b) => a.total[description].localeCompare(b.total[description])),
          order: 'DSC',
          orderedBy: description,
        })
      }
    } else if(this.state.orderedBy === description && this.state.order === 'DSC') {
      this.setState({
        dataOrdered: this.props.data.sort((a,b) => b.total[description] - a.total[description]),
        order: 'ASC',
      })
    } else {
      this.setState({
        dataOrdered: this.props.data.sort((a,b) => a.total[description] - b.total[description]),
        orderedBy: description,
        order: 'DSC',
      })
    }
  }

  render() {
    const { classes } = this.props

    return(
      <div>
        {this.props.data ?
          <div>
            <Typography variant="caption" className={classes.title}>LOCATIONS</Typography>
            <Paper style={{marginTop: '15px'}} className={classes.paper}>
              <div className={classes.table}>
              <Table>
                <TableHead style={{backgroundColor: '#283891'}}>
                  <TableRow>
                    <TableCell className={classes.header} onClick={() => this.handleSortColumn('Label')}>
                      <div style={{display: 'inline-flex', alignItems: 'center'}}>
                        <Typography variant="caption" className={classes.header}>Location</Typography>
                        {this.state.orderedBy === 'Label' ? this.state.order === 'DSC' ? <ImSortAlphaAsc style={{fontSize: '13px', marginLeft: '5px', marginTop: '-3px'}}/> : <ImSortAlphaDesc style={{fontSize: '13px', marginLeft: '5px', marginTop: '-3px'}}/> : null}
                      </div>
                    </TableCell>
                    <TableCell className={classes.header} onClick={() => this.handleSortColumn('Cost')} align="right">
                      <div style={{display: 'inline-flex', alignItems: 'center'}}>
                        <Typography variant="caption" className={classes.header}>Spend</Typography>
                        {this.state.orderedBy === 'Cost' ? this.state.order === 'DSC' ? <ImSortNumericAsc style={{fontSize: '13px', marginLeft: '5px', marginTop: '-3px'}}/> : <ImSortNumbericDesc style={{fontSize: '13px', marginLeft: '5px', marginTop: '-3px'}}/> : null}
                      </div>
                    </TableCell>
                    <TableCell className={classes.header} onClick={() => this.handleSortColumn('Sales')} align="right">
                      <div style={{display: 'inline-flex', alignItems: 'center'}}>
                        <Typography variant="caption" className={classes.header}>Sales</Typography>
                        {this.state.orderedBy === 'Sales' ? this.state.order === 'DSC' ? <ImSortNumericAsc style={{fontSize: '13px', marginLeft: '5px', marginTop: '-3px'}}/> : <ImSortNumbericDesc style={{fontSize: '13px', marginLeft: '5px', marginTop: '-3px'}}/> : null}
                      </div>
                    </TableCell>
                    <TableCell className={classes.header} onClick={() => this.handleSortColumn('Mailed')} align="right">
                      <div style={{display: 'inline-flex', alignItems: 'center'}}>
                        <Typography variant="caption" className={classes.header}>Mailed</Typography>
                        {this.state.orderedBy === 'Mailed' ? this.state.order === 'DSC' ? <ImSortNumericAsc style={{fontSize: '13px', marginLeft: '5px', marginTop: '-3px'}}/> : <ImSortNumbericDesc style={{fontSize: '13px', marginLeft: '5px', marginTop: '-3px'}}/> : null}
                      </div>
                    </TableCell>
                    <TableCell className={classes.header} onClick={() => this.handleSortColumn('Responses')} align="right">
                      <div style={{display: 'inline-flex', alignItems: 'center'}}>
                        <Typography variant="caption" className={classes.header}>Responses</Typography>
                        {this.state.orderedBy === 'Responses' ? this.state.order === 'DSC' ? <ImSortNumericAsc style={{fontSize: '13px', marginLeft: '5px', marginTop: '-3px'}}/> : <ImSortNumbericDesc style={{fontSize: '13px', marginLeft: '5px', marginTop: '-3px'}}/> : null}
                      </div>
                    </TableCell>
                    <TableCell className={classes.header} onClick={() => this.handleSortColumn('Res_Rate')} align="right">
                      <div style={{display: 'inline-flex', alignItems: 'center'}}>
                        <Typography variant="caption" className={classes.header}>Response Rate</Typography>
                        {this.state.orderedBy === 'Res_Rate' ? this.state.order === 'DSC' ? <ImSortNumericAsc style={{fontSize: '13px', marginLeft: '5px', marginTop: '-3px'}}/> : <ImSortNumbericDesc style={{fontSize: '13px', marginLeft: '5px', marginTop: '-3px'}}/> : null}
                      </div>
                    </TableCell>
                    <TableCell className={classes.header} onClick={() => this.handleSortColumn('HO_Sales')} align="right">
                      <div style={{display: 'inline-flex', alignItems: 'center'}}>
                        <Typography variant="caption" className={classes.header}>Holdout Sales</Typography>
                        {this.state.orderedBy === 'HO_Sales' ? this.state.order === 'DSC' ? <ImSortNumericAsc style={{fontSize: '13px', marginLeft: '5px', marginTop: '-3px'}}/> : <ImSortNumbericDesc style={{fontSize: '13px', marginLeft: '5px', marginTop: '-3px'}}/> : null}
                      </div>
                    </TableCell>
                    <TableCell className={classes.header} onClick={() => this.handleSortColumn('HO_Count')} align="right">
                      <div style={{display: 'inline-flex', alignItems: 'center'}}>
                        <Typography variant="caption" className={classes.header}>Holdout Count</Typography>
                        {this.state.orderedBy === 'HO_Count' ? this.state.order === 'DSC' ? <ImSortNumericAsc style={{fontSize: '13px', marginLeft: '5px', marginTop: '-3px'}}/> : <ImSortNumbericDesc style={{fontSize: '13px', marginLeft: '5px', marginTop: '-3px'}}/> : null}
                      </div>
                    </TableCell>
                    <TableCell className={classes.header} onClick={() => this.handleSortColumn('HO_Resp')} align="right">
                      <div style={{display: 'inline-flex', alignItems: 'center'}}>
                        <Typography variant="caption" className={classes.header}>Holdout Responses</Typography>
                        {this.state.orderedBy === 'HO_Resp' ? this.state.order === 'DSC' ? <ImSortNumericAsc style={{fontSize: '13px', marginLeft: '5px', marginTop: '-3px'}}/> : <ImSortNumbericDesc style={{fontSize: '13px', marginLeft: '5px', marginTop: '-3px'}}/> : null}
                      </div>
                    </TableCell>
                      <TableCell className={classes.header} onClick={() => this.handleSortColumn('HO_Res_Rate')} align="right">
                      <div style={{display: 'inline-flex', alignItems: 'center'}}>
                        <Typography variant="caption" className={classes.header}>Holdout Response Rate</Typography>
                        {this.state.orderedBy === 'HO_Res_Rate' ? this.state.order === 'DSC' ? <ImSortNumericAsc style={{fontSize: '13px', marginLeft: '5px', marginTop: '-3px'}}/> : <ImSortNumbericDesc style={{fontSize: '13px', marginLeft: '5px', marginTop: '-3px'}}/> : null}
                      </div>
                    </TableCell>
                    <TableCell className={classes.header} onClick={() => this.handleSortColumn('ADJ_Res_Rate')} align="right">
                      <div style={{display: 'inline-flex', alignItems: 'center'}}>
                        <Typography variant="caption" className={classes.header}>Inc Response Rate</Typography>
                        {this.state.orderedBy === 'ADJ_Res_Rate' ? this.state.order === 'DSC' ? <ImSortNumericAsc style={{fontSize: '13px', marginLeft: '5px', marginTop: '-3px'}}/> : <ImSortNumbericDesc style={{fontSize: '13px', marginLeft: '5px', marginTop: '-3px'}}/> : null}
                      </div>
                    </TableCell>
                    <TableCell className={classes.header} onClick={() => this.handleSortColumn('Avg_Ticket')} align="right">
                      <div style={{display: 'inline-flex', alignItems: 'center'}}>
                        <Typography variant="caption" className={classes.header}>Avg Ticket</Typography>
                        {this.state.orderedBy === 'Avg_Ticket' ? this.state.order === 'DSC' ? <ImSortNumericAsc style={{fontSize: '13px', marginLeft: '5px', marginTop: '-3px'}}/> : <ImSortNumbericDesc style={{fontSize: '13px', marginLeft: '5px', marginTop: '-3px'}}/> : null}
                      </div>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.props.data.length > 10 ?
                    this.props.data
                    .slice(this.state.page * this.state.rowsPerPage, this.state.page * this.state.rowsPerPage + this.state.rowsPerPage)
                    .map((row, i) => (
                      <TableRow key={i} style={this.props.data.length % 2 === 0 ? i % 2 !== 0 ? {backgroundColor: '#efefef'} : {} : i % 2 === 0 ? {backgroundColor: '#efefef'} : {}}>
                        <TableCell><Typography variant="caption">{row.label.toUpperCase()}</Typography></TableCell>
                        <TableCell align="right"><Typography variant="caption">${Math.round(row.total.Cost).toLocaleString('en')}</Typography></TableCell>
                        <TableCell align="right"><Typography variant="caption">${Math.round(row.total.Sales).toLocaleString('en')}</Typography></TableCell>
                        <TableCell align="right"><Typography variant="caption">{Math.round(row.total.Mailed).toLocaleString('en')}</Typography></TableCell>
                        <TableCell align="right"><Typography variant="caption">{Math.round(row.total.Responses).toLocaleString('en')}</Typography></TableCell>
                        <TableCell align="right"><Typography variant="caption">{(row.total.Responses / row.total.Mailed * 100).toFixed(2) + '%'}</Typography></TableCell>
                        <TableCell align="right"><Typography variant="caption">{'$' + Math.round(row.total.HO_Sales).toLocaleString('en')}</Typography></TableCell>
                        <TableCell align="right"><Typography variant="caption">{Math.round(row.total.HO_Count).toLocaleString('en')}</Typography></TableCell>
                        <TableCell align="right"><Typography variant="caption">{Math.round(row.total.HO_Resp).toLocaleString('en')}</Typography></TableCell>
                        <TableCell align="right"><Typography variant="caption">{(row.total.HO_Resp / row.total.HO_Count * 100).toFixed(2) + '%'}</Typography></TableCell>
                        <TableCell align="right"><Typography variant="caption">{(((row.total.Responses / row.total.Mailed) - (row.total.HO_Resp / row.total.HO_Count)) * 100).toFixed(2) + '%'}</Typography></TableCell>
                        <TableCell align="right"><Typography variant="caption">${row.total.Responses > 0 ? Math.round(row.total.Sales / row.total.Responses).toLocaleString('en') : 0}</Typography></TableCell>
                      </TableRow>
                    ))
                  :
                    this.props.data.map((row, i) => (
                      <TableRow key={i}>
                        <TableCell><Typography variant="caption">{row.label.toUpperCase()}</Typography></TableCell>
                        <TableCell align="right"><Typography variant="caption">${Math.round(row.total.Cost).toLocaleString('en')}</Typography></TableCell>
                        <TableCell align="right"><Typography variant="caption">${Math.round(row.total.Sales).toLocaleString('en')}</Typography></TableCell>
                        <TableCell align="right"><Typography variant="caption">{Math.round(row.total.Mailed).toLocaleString('en')}</Typography></TableCell>
                        <TableCell align="right"><Typography variant="caption">{Math.round(row.total.Responses).toLocaleString('en')}</Typography></TableCell>
                        <TableCell align="right"><Typography variant="caption">{(row.total.Res_Rate * 100).toFixed(2) + '%'}</Typography></TableCell>
                        <TableCell align="right"><Typography variant="caption">{'$' + Math.round(row.total.HO_Sales).toLocaleString('en')}</Typography></TableCell>
                        <TableCell align="right"><Typography variant="caption">{Math.round(row.total.HO_Count).toLocaleString('en')}</Typography></TableCell>
                        <TableCell align="right"><Typography variant="caption">{Math.round(row.total.HO_Resp).toLocaleString('en')}</Typography></TableCell>
                        <TableCell align="right"><Typography variant="caption">{(row.total.HO_Res_Rate * 100).toFixed(2) + '%'}</Typography></TableCell>
                        <TableCell align="right"><Typography variant="caption">{(row.total.ADJ_Res_Rate * 100).toFixed(2) + '%'}</Typography></TableCell>
                        <TableCell align="right"><Typography variant="caption">${row.total.Responses > 0 ? Math.round(row.total.Sales / row.total.Responses).toLocaleString('en') : 0}</Typography></TableCell>
                      </TableRow>
                    ))
                  }
                </TableBody>
              </Table>
              </div>

              <TablePagination
                // rowsPerPageOptions={this.props.data.length > 20 ? [10, 20, this.props.data.length] : [10 , this.props.data.length]}
                rowsPerPageOptions={this.props.data.length > 20 ? [Math.round((this.props.data.length / 4) / 10) * 10, Math.round((this.props.data.length / 2) / 10) * 10, this.props.data.length] : [Math.round((this.props.data.length / 4) / 5) * 5, Math.ceil((this.props.data.length / 2) / 5) * 5, this.props.data.length]}
                component="div"
                count={this.props.data.length}
                rowsPerPage={this.state.rowsPerPage}
                page={this.state.page}
                onChangePage={this.handleChangePage}
                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                style={this.props.data.length > 10 ? {} : {display: 'none'}}
              />
            </Paper>
          </div>
          :
          <div/>
        }
      </div>
    )
  }
}

export default withStyles(styles)(Locations)
